import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { findData, recordFiltering } from '~/store/modules/padroes/actions';

import { number } from '~/helpers';

import MyForm from './form';

function Padroes() {
  const redux = useSelector((state) => state.padroes);

  const header = useMemo(
    () => [
      {
        id: 'post_desc',
        label: 'Posto',
      },
      {
        id: 'cont_tafi',
        label: 'Num. Tqs',
      },
      {
        id: 'capacidade',
        label: 'Capacidade',
        formatted: (value) => number(value, 2),
        align: 'right',
      },
      {
        id: 'popa_val_dif_max_estoque',
        label: 'Turno/Descarga Litros',
        formatted: (value) => number(value, 2),
        align: 'right',
      },
      {
        id: 'popa_per_dif_max_estoque',
        label: 'Turno/Descarga %',
        formatted: (value) => number(value, 2),
        align: 'right',
      },
      {
        id: 'popa_per_acumulado_mes',
        label: 'Acumulado mês %',
        formatted: (value) => number(value, 2),
        align: 'right',
      },
    ],
    []
  );

  return (
    <UnidataTable
      fixed
      header={header}
      read={recordFiltering}
      find={findData}
      form={MyForm}
      redux={redux}
      title="Padrões"
      detach="rownum"
      keys={['post_cod_posto']}
      create={false}
      delete={false}
    />
  );
}

export default Padroes;
